/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : TemplateManager.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, IconButton, Divider } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import CustomPaginationV2 from "../../../components/customComponentsV2/common/pagination/CustomPaginationV2";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions } from "../../../redux/actions";

function TemplateManager({ config, refreshKey }) {
  const dispatch = useDispatch();
  const dataState = useSelector(config.selector);

  useEffect(() => {
    console.log("dataState", dataState);
    console.log("config", config);
  }, [dataState]);

  const [page, setPage] = useState(1);
  const [rowsPerPage] = useState(25);

  useEffect(() => {
    dispatch(
      HandleApiActions({
        ...config.fetchAction,
        params: {
          page_number: page,
          page_size: rowsPerPage,
        },
      }),
    );
  }, [dispatch, page, rowsPerPage, config.fetchAction, refreshKey]);

  const items = dataState?.items || dataState?.dynamicTemplate || [];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Grid container spacing={2}>
        {items?.map((item) => (
          <Grid item xs={12} sm={6} md={6} lg={4} key={item.id}>
            <Box
              sx={{
                p: 2,
                height: "17rem",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                border: "1px solid gray",
                width: "13rem",
                backgroundColor: "#fff",
              }}
            >
              {/* Header */}

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <CustomButtonV2
                  btnName="Edit"
                  size="small"
                  handleOnClick={() => config.onEdit(item)}
                />

                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: ".8rem",
                    color: item?.status === 100 ? "#555" : "green",
                  }}
                >
                  {item?.status === 100 ? "Draft" : "Active"}
                </Typography>
              </Box>

              {/* View Icon */}
              <IconButton
                onClick={() => config.onView(item)}
                sx={{
                  width: 60,
                  height: 60,
                  alignSelf: "center",
                  borderRadius: "50%",
                  backgroundColor: "#fff",
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                <VisibilityIcon sx={{ fontSize: 28 }} />
              </IconButton>

              {/* Name */}
              <Typography
                sx={{
                  fontWeight: "bold",
                  fontSize: ".8rem",
                  mt: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                title={item?.name}
              >
                {item?.name}
              </Typography>

              <Divider sx={{ my: 1 }} />

              {/* Type */}
              <Typography
                sx={{
                  fontSize: ".8rem",
                  fontWeight: 500,
                  color: "gray",
                }}
              >
                {config.typeResolver ? config.typeResolver(item) : "Template"}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Pagination */}
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <CustomPaginationV2
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(value) => setPage(value)}
          totalItems={dataState?.totalCount}
        />
      </Box>
    </Box>
  );
}

export default TemplateManager;
